import React from 'react';
import styled from 'styled-components';
import { Colors, Fonts } from '@prezi/dragon';

export const AISearchBarContainer = styled.div`
    display: flex;
    height: 58px;
    padding: 8px 32px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    background: var(--Neutral-neutral800, ${Colors.neutral800});
    position: relative;
    justify-content: center;
`;

export const SearchGroup = styled.div`
    display: flex;
    min-width: 420px;
    max-width: 748px;
    width: 100%;
    padding-left: 15px;
    justify-content: flex-end;
    align-items: center;
    gap: 0;
`;

export const SearchInput = styled.input`
    flex: 1 1 auto;
    height: 42px;
    border-radius: 8px 0 0 8px;
    border: none;
    padding: 0 16px;
    background: ${Colors.white};
    color: ${Colors.neutral700};
    box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.5);
    font-family: ${Fonts.raleway};

    &::placeholder {
        color: ${Colors.neutral700};
        opacity: 1;
        font-family: ${Fonts.raleway};
        font-size: 14px;
        font-weight: 400;
    }
`;

export const CreateWithAIButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    padding: 0 16px;
    gap: 8px;
    border-radius: 0 8px 8px 0;
    border: none;
    cursor: pointer;
    color: ${Colors.white};
    font-family: ${Fonts.raleway};
    font-weight: 600;
    font-size: 14px;
    background: var(--Gradient-AI, linear-gradient(135deg, #1a46bc 0%, #993bc6 76.42%)) !important;
    border-color: transparent !important;

    &:hover {
        background: var(--Gradient-AI, linear-gradient(135deg, #1634a3 0%, #8533ad 76.42%)) !important;
        border-color: transparent !important;
    }
`;

export const LeftActions = styled.div`
    position: absolute;
    left: 32px;
    display: flex;
    align-items: center;
    height: 100%;
`;

export const RightActions = styled.div`
    position: absolute;
    right: 32px;
    display: flex;
    align-items: center;
    height: 100%;
`;

export const PreziLogoWrapper = styled.div`
    width: 100px;
    height: 35px;
    background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 35"></svg>')
        no-repeat center;
`;

export function PlaceholderStyle() {
    const className = 'ai-search-placeholder-style';
    const style = `color: ${Colors.neutral700} !important; opacity: 1;`;
    return React.createElement(
        'style',
        {},
        `
            .${className}::placeholder { ${style} }
            .${className}::-webkit-input-placeholder { ${style} }
            .${className}::-moz-placeholder { ${style} }
            .${className}:-ms-input-placeholder { ${style} }
            .${className}:-moz-placeholder { ${style} }
        `,
    );
}
